/**
 * WashPros SMS A2P consent strings.
 *
 * These verbatim texts are stored in MongoDB on signup/booking/waitlist
 * submissions for Twilio A2P 10DLC compliance. They MUST NOT be translated
 * or modified — they are the exact language reviewed and submitted to
 * Twilio for campaign approval.
 *
 * Centralized here (outside `src/components/**`) so the i18n_lint guard
 * does not flag them as English UI leaks while keeping the source of
 * truth single.
 */
export const CUSTOMER_SMS_CONSENT_TEXT =
  "I agree to receive SMS text messages from WashPros Global Services LLC about my account, " +
  "waitlist status, bookings, service updates, support requests, and operational notices. " +
  "Message frequency varies. Message and data rates may apply. " +
  "Reply STOP to opt out or HELP for help. " +
  "Consent is not required to purchase services or join the waitlist.";

export const VENDOR_SMS_CONSENT_TEXT =
  "I agree to receive SMS text messages from WashPros Global Services LLC about my vendor application, " +
  "account, service updates, support requests, compliance notices, and operational notices. " +
  "Message frequency varies. Message and data rates may apply. " +
  "Reply STOP to opt out or HELP for help. " +
  "Consent is not required to apply as a vendor.";
